export default {
  // TODO: Implement versioning when api does it
  getDefaultState: () => {
    return {
      publicConfig: {},
      // publicConfigVersion: '1.3',
      privateConfig: {},
      // privateConfigVersion: '1.3',
      isCallingConfig: false,
      currencies: [],
      zohoPlans: []
    }
  }
}
